import { Component, OnInit, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { User, Location, PostLocationsModel, AppRole } from '../models/user.model';
import { Unsubscribable as AnonymousSubscription } from 'rxjs';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { NgForm } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';

@Component({
  selector: 'app-post-user',
  templateUrl: './post-user.component.html',
  styleUrls: ['./post-user.component.css']
})
export class PostUserComponent implements OnInit {
  public postDetails: Post[];
  newLocationIds: number[];
  enableSave = false;
  currentUser: User;
  userRoles: AppRole[];
  // filteredCountries: string[];
  // locationName: string[] = [];
  // location: string;

  @Input()
  userLocations: PostLocationsModel[];
  @Output()
  deleteLocation = new EventEmitter<number>();
  @Output()
  addLocations = new EventEmitter<number[]>();
  showProfilesetupAlert: boolean=false;
  // dialog display
  addLocationsDisplay = false;
  // lookup data
  //@Input() regions: Location[];
  @Input()
  countries: Location[];

  constructor(
    private lookupService: LookupService,
    private registrationService: RegistrationService,
    private authUser: AuthUserService
  ) {}

  ngOnInit() {
    this.currentUser = this.authUser._user;
    this.userRoles = this.currentUser.userRoles;
    this.userLocations.sort(
      (a, b): number => {
        if (a.region < b.region) return -1;
        if (a.region > b.region) return 1;
        return 0;
      }
    );

    this.postDetails = new Array<Post>();
    this.addPostDetail(); // add empty row for reporting Post selection
    this.newLocationIds = new Array<number>();
    if(this.userLocations.length<1  )      this.showProfilesetupAlert = true;
  }

  // filterCountries(event): void {
  //   // this.filterCountries = this.countries.filter(c => c.locationName.startsWith(event.query));
  //   this.filteredCountries = [];
  //   for (let i = 0; i < this.countries.length; i++) {
  //     if (this.countries[i].locationName.toLowerCase().indexOf(event.query.toLowerCase()) == 0) {
  //       this.filteredCountries.push(this.countries[i].locationName);
  //     }
  //   }
  // }

  showAddLocations() {
    this.addLocationsDisplay = true;
    this.postDetails = new Array<Post>();
    this.addPostDetail();
    this.countries.sort(
      (a, b): number => {
        if (a.locationName < b.locationName) return -1;
        if (a.locationName > b.locationName) return 1;
        return 0;
      }
    );
    if(this.userLocations.length>=0)   this.showProfilesetupAlert = false;        
  }
  hideAddLocationDialog() {
    this.addLocationsDisplay = false;
        if(this.userLocations.length<=0)   this.showProfilesetupAlert = true;   
  }

  addPostDetail() {
    // new reporting Post location selection, initialize w/ null values
    this.postDetails.push(new Post(null, null, null));
  }

  deletePostDetail(postDetail: Post) {
    const i = this.postDetails.indexOf(postDetail);
    this.postDetails.splice(i, 1);
  }

  onAddLocations() {
    this.postDetails.forEach(element => {
      this.newLocationIds.push(element.postId);
    });
    this.addLocations.emit(this.newLocationIds);

    // reset PostDetails and LocationIds selections
    // add empty row
    this.postDetails = new Array<Post>();
    this.addPostDetail();

    this.newLocationIds = new Array<number>();

    // hide add locations dialog
    this.addLocationsDisplay = false;  
    if(this.userLocations.length>0)     this.showProfilesetupAlert = false;       
  }

  onDeleteLocation(postId: number) {
    this.deleteLocation.emit(postId);
     if(this.userLocations.length = 0)      this.showProfilesetupAlert = true;            
  }

  // onChangeRegion(postDetail: Post, region) {
  //   postDetail.regionId = region.id;
  //   this.lookupService.getChildLocations(region.id).subscribe(
  //     (data: Location[]) => {
  //       postDetail.countries = data;
  //     }
  //   );
  // }

  onChangeCountry(postDetail: Post, country) {
    postDetail.countryId = country.id;
    this.lookupService.getChildLocations(country.id).subscribe((data: Location[]) => {
      postDetail.posts = data.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
  }

  onChangePost(postDetail: Post, post) {
    postDetail.postId = post.id;
    this.enableSave = true;
  }
}

export class Post {
  countries: Location[];
  posts: Location[];

  constructor(public regionId: number, public countryId: number, public postId: number) {}
}
